export default "__VITE_ASSET__3b5l0t7u__"